import { get } from 'lodash'
import { isMobile } from 'react-device-detect'
import { BOS_STATUS, BOS_USER_ROLE } from 'lib/bos'
import { AD_STATUS } from 'lib/ad'
import { isProductionHost } from 'lib/env'
import { logException } from 'lib/errors'
import { getModalUrl } from 'lib/modals'
import { isBosActive } from 'lib/utils/store/bos'
import CarVehicle from './wrappers/CarVehicle'
import BikeVehicle from './wrappers/BikeVehicle'
import DisabledVehicle from './wrappers/DisabledVehicle'
import CaravanVehicle from './wrappers/CaravanVehicle'
import MachineVehicle from './wrappers/MachineVehicle'
import PartVehicle from './wrappers/PartVehicle'

export const VERTICAL = Object.freeze({
    CAR: 'car',
    AUTOTALLI: 'autotalli',
    BIKE: 'bike',
    MACHINE: 'machine',
    BOAT: 'boat',
    PART: 'part',
    CARAVAN: 'caravan',
    CABIN: 'cabin',
    RENT: 'rent',
    REKKARI: 'rekkari',
    BAANA: 'baana',
    INBOX: 'inbox',
})

export const ENABLED_VEHICLE_VERTICALS = Object.freeze([
    VERTICAL.CAR,
    VERTICAL.BIKE,
    VERTICAL.CARAVAN,
    VERTICAL.PART,
    VERTICAL.BOAT,
    VERTICAL.MACHINE,
])

export const VERTICALS_WITH_EASY_DEALS = Object.freeze([
    VERTICAL.CAR,
    VERTICAL.BIKE,
    VERTICAL.MACHINE,
    VERTICAL.CARAVAN,
])

export const ENABLED_BOS_VERTICALS = Object.freeze([
    VERTICAL.BIKE,
    VERTICAL.CAR,
    VERTICAL.CARAVAN,
    VERTICAL.MACHINE
])

export const VEHICLE_TYPES = Object.freeze({
    // car
    CAR: '1',
    VAN: '2',
    MINIBUS: '3',
    LIGHT_TRUCK: '4',

    // bike
    MOTORBIKE: '5',
    MOPED: '6',
    SCOOTER: '7',
    SNOWMOBILE: '8',
    ATV: '9',
    MOPED_CAR: '10',
    OTHER_BIKE: '11',
    GO_CART: '21',
    MINIMOTO: '22',
    MOTORIZED_BICYCLE: '23',
    CROSSKART: '24',
    SENIOR_VEHICLE: '25',
    THREEWHEELER: '26',
    ELECTRIC_VEHICLES: '27',
    FOURWHEELER: '28',

    // caravan
    TRAVEL_TRUCK: '18',
    TRAVEL_BOX: '19',
    ROLLING_HOME: '20',

    // machine
    TRUCK: '12',
    BUS: '13',
    TRACKTOR: '14',
    TRAILER: '15',
    OTHER_MACHINE: '16',

    // boat
    TRAWLER: '29',
    HYDROCOPTER: '30',
    HOVERCRAFT: '31',
    JOLLYBOAT: '32',
    KAJAK: '33',
    CANOE: '34',
    KATAMARAN: '35',
    RUBBER_BOAT: '36',
    ENGINE: '37',
    MOTOR_SAILOR: '38',
    MOTOR_BOAT: '39',
    RIB_BOAT: '42',
    SAILING_BOAT: '41',
    ROWING_BOAT: '43',
    WORKBOAT: '46',
    WATERCRAFT: '47',

    // part
    PART_TRAILER: '17',
})

export const ENABLED_VEHICLE_TYPES = Object.freeze([
    // car
    VEHICLE_TYPES.CAR,
    VEHICLE_TYPES.VAN,
    VEHICLE_TYPES.MINIBUS,
    VEHICLE_TYPES.LIGHT_TRUCK,

    // bike
    VEHICLE_TYPES.MOTORBIKE,
    VEHICLE_TYPES.MOPED,
    VEHICLE_TYPES.SCOOTER,
    VEHICLE_TYPES.SNOWMOBILE,
    VEHICLE_TYPES.ATV,
    VEHICLE_TYPES.MOPED_CAR,
    VEHICLE_TYPES.OTHER_BIKE,

    // caravan
    VEHICLE_TYPES.TRAVEL_BOX,
    VEHICLE_TYPES.TRAVEL_TRUCK,
    VEHICLE_TYPES.ROLLING_HOME,

    // machine
    VEHICLE_TYPES.TRUCK,
    VEHICLE_TYPES.BUS,
    VEHICLE_TYPES.TRACKTOR,
    VEHICLE_TYPES.TRAILER,
    VEHICLE_TYPES.OTHER_MACHINE,

    // part
    VEHICLE_TYPES.PART_TRAILER,

    // boat
    // VEHICLE_TYPES.TRAWLER,
    // VEHICLE_TYPES.HYDROCOPTER,
    // VEHICLE_TYPES.HOVERCRAFT,
    // VEHICLE_TYPES.JOLLYBOAT,
    // VEHICLE_TYPES.KAJAK,
    // VEHICLE_TYPES.CANOE,
    // VEHICLE_TYPES.KATAMARAN,
    // VEHICLE_TYPES.RUBBER_BOAT,
    // VEHICLE_TYPES.ENGINE,
    // VEHICLE_TYPES.MOTOR_SAILOR,
    // VEHICLE_TYPES.MOTOR_BOAT,
    // VEHICLE_TYPES.RIB_BOAT,
    // VEHICLE_TYPES.SAILING_BOAT,
    // VEHICLE_TYPES.ROWING_BOAT,
    // VEHICLE_TYPES.WORKBOAT,
    // VEHICLE_TYPES.WATERCRAFT,
])

export const VEHICLE_TYPES_WITH_PREFILL_API = Object.freeze([
    // car
    VEHICLE_TYPES.CAR,
    VEHICLE_TYPES.VAN,
    VEHICLE_TYPES.MINIBUS,
    VEHICLE_TYPES.LIGHT_TRUCK,
])

export const VEHICLE_TYPES_WITH_PRICE_ESTIMATE_API = Object.freeze([
    // car
    VEHICLE_TYPES.CAR,
    VEHICLE_TYPES.VAN,
    VEHICLE_TYPES.MINIBUS,
    VEHICLE_TYPES.LIGHT_TRUCK,

    // bike
    VEHICLE_TYPES.MOTORBIKE,
    VEHICLE_TYPES.MOPED,
    VEHICLE_TYPES.SCOOTER,
    VEHICLE_TYPES.SNOWMOBILE,
    VEHICLE_TYPES.ATV,
    VEHICLE_TYPES.MOPED_CAR,
    VEHICLE_TYPES.OTHER_BIKE,
])

export const VEHICLE_TYPES_WITH_AUTOVISTA_ESTIMATE = Object.freeze([
    VEHICLE_TYPES.CAR,
    VEHICLE_TYPES.VAN,
    VEHICLE_TYPES.MINIBUS,
    VEHICLE_TYPES.LIGHT_TRUCK,
])

export const VEHICLE_ACTIONS = Object.freeze({
    SET_ACTIVE: 'SET_ACTIVE',
    DELETE: 'DELETE',
    SET_STATUS_OLD: 'SET_STATUS_OLD',
    SET_STATUS_SOLD: 'SET_STATUS_SOLD',
    SET_STATUS_ACTIVE: 'SET_STATUS_ACTIVE',
    SHOW_BOS: 'SHOW_BOS',
    CREATE_AD: 'CREATE_AD',
    CREATE_BOS: 'CREATE_BOS',
})

export const VEHICLE_AD_ACTIONS = Object.freeze({
    SHOW: 'SHOW',
    EDIT: 'EDIT',
    SET_SOLD: 'SET_SOLD',
    SET_ACTIVE: 'SET_ACTIVE',
    DELETE: 'DELETE',
})

export const VEHICLE_SALES_METHOD = Object.freeze({
    DIRECT: 'DIRECT',
    EXCHANGE: 'EXCHANGE',
})

export const VEHICLE_GROUPS = Object.freeze({
    CARS: {
        name: 'cars',
        primaryVerticals: [
            VERTICAL.CAR,
            VERTICAL.CARAVAN,
            VERTICAL.MACHINE,
            VERTICAL.PART,
        ],
        vehicleTypes: [
            // car
            VEHICLE_TYPES.CAR,
            VEHICLE_TYPES.VAN,
            VEHICLE_TYPES.MINIBUS,
            VEHICLE_TYPES.LIGHT_TRUCK,

            // caravan
            VEHICLE_TYPES.TRAVEL_TRUCK,
            VEHICLE_TYPES.TRAVEL_BOX,
            VEHICLE_TYPES.ROLLING_HOME,

            // machine
            VEHICLE_TYPES.TRUCK,
            VEHICLE_TYPES.BUS,
            VEHICLE_TYPES.TRACKTOR,
            VEHICLE_TYPES.TRAILER,
            VEHICLE_TYPES.OTHER_MACHINE,

            // bike
            VEHICLE_TYPES.ATV,
            VEHICLE_TYPES.MOPED_CAR,
            VEHICLE_TYPES.GO_CART,
            VEHICLE_TYPES.CROSSKART,

            // part
            VEHICLE_TYPES.PART_TRAILER,
        ],
    },
    MOTOS: {
        name: 'motos',
        primaryVerticals: [
            VERTICAL.BIKE,
        ],
        vehicleTypes: [
            // bike
            VEHICLE_TYPES.MOTORBIKE,
            VEHICLE_TYPES.MOPED,
            VEHICLE_TYPES.SCOOTER,
            VEHICLE_TYPES.SNOWMOBILE,
            VEHICLE_TYPES.ATV,
            VEHICLE_TYPES.MOPED_CAR,
            VEHICLE_TYPES.OTHER_BIKE,
            VEHICLE_TYPES.GO_CART,
            VEHICLE_TYPES.MINIMOTO,
            VEHICLE_TYPES.MOTORIZED_BICYCLE,
            VEHICLE_TYPES.CROSSKART,
            VEHICLE_TYPES.SENIOR_VEHICLE,
            VEHICLE_TYPES.THREEWHEELER,
            VEHICLE_TYPES.ELECTRIC_VEHICLES,
            VEHICLE_TYPES.FOURWHEELER,
        ],
    },
    BOATS: {
        name: 'boats',
        primaryVerticals: [
            VERTICAL.BOAT,
        ],
        vehicleTypes: [
            // boats
            VEHICLE_TYPES.TRAWLER,
            VEHICLE_TYPES.HYDROCOPTER,
            VEHICLE_TYPES.HOVERCRAFT,
            VEHICLE_TYPES.JOLLYBOAT,
            VEHICLE_TYPES.KAJAK,
            VEHICLE_TYPES.CANOE,
            VEHICLE_TYPES.KATAMARAN,
            VEHICLE_TYPES.RUBBER_BOAT,
            VEHICLE_TYPES.ENGINE,
            VEHICLE_TYPES.MOTOR_SAILOR,
            VEHICLE_TYPES.MOTOR_BOAT,
            VEHICLE_TYPES.RIB_BOAT,
            VEHICLE_TYPES.SAILING_BOAT,
            VEHICLE_TYPES.ROWING_BOAT,
            VEHICLE_TYPES.WORKBOAT,
            VEHICLE_TYPES.WATERCRAFT,
        ],
    },
})

export const VEHICLE_STATUS = Object.freeze({
    ACTIVE: 'ACTIVE',
    SOLD: 'SOLD',
    OLD: 'OLD',
    PENDING: 'PENDING',
    DELETED: 'DELETED'
})

export const VEHICLE_OLD_STATUS_OPTIONS = Object.freeze({
    GIVEN: 'given',
    LEASING: 'leasing',
    SCRAPPED: 'scrapped',
    OTHER: 'other',
})

export const FORM_OF_OWNERSHIPS_OPTIONS = [
    { value: 1, name: 'owner' },
    { value: 2, name: 'holder' },
    { value: 3, name: 'other' },
]

export const FORM_OF_OWNERSHIP_BY_ID = Object.freeze({
    1: 'owner',
    2: 'holder',
    3: 'other',
    4: 'undefined'
})

export const VEHICLE_AD_SKETCH_CREATE_ACTIONS = Object.freeze({
    CREATE: 'create', // will not overwrite or append to existing sketch
    OVERWRITE: 'overwrite',
    APPEND: 'append',
    CONTINUE: 'continue',
})

export const VEHICLE_AD_SKETCH_RESPONSE_TYPE = Object.freeze({
    EXISTS_FOR_THIS_VEHICLE: 'sketchExistsForThisVehicle',
    CREATED: 'created',
    SUCCESS: 'success',
})

export const VEHICLE_INSPECTION_STATUS = Object.freeze({
    INTERRUPTED: 'INTERRUPTED',
    ACCEPTED: 'ACCEPTED',
    REJECTED: 'REJECTED',
    ANNULLED: 'ANNULLED',
})

export const VEHICLE_INSPECTION_STATUS_BY_TRAFI_CODE = Object.freeze({
    1: VEHICLE_INSPECTION_STATUS.INTERRUPTED,
    2: VEHICLE_INSPECTION_STATUS.ACCEPTED,
    3: VEHICLE_INSPECTION_STATUS.REJECTED,
    4: VEHICLE_INSPECTION_STATUS.ANNULLED,
})

export const getVerticalUrl = (t, vertical) => {
    const env = isProductionHost() ? 'production' : 'development'
    return t(`vehicles:vertical.${vertical}.url.${env}`)
}

export const getVerticalPostAdUrl = (t, vertical) => {
    const env = isProductionHost() ? 'production' : 'development'
    return vertical === VERTICAL.CAR || vertical === VERTICAL.BIKE
        ? t(`vehicles:vertical.${vertical}.url.${env}`) + '/jata-uusi-ilmoitus'
        : t(`vehicles:vertical.${vertical}.url.${env}`) + '/postAd.php'
}

export const getVerticalTitle = (t, vertical) => {
    return t(`vehicles:vertical.${vertical}.title`)
}

export const getVerticalName = (t, vertical) => {
    return t(`vehicles:vertical.${vertical}.name`)
}

export const getAnyVehicleBos = (vehicle) => {
    return vehicle.bos || vehicle.createdFromBos
}

export const getAnyVehicleBosStatus = (vehicle) => {
    return get(getAnyVehicleBos(vehicle), 'status', false)
}

export const vehicleInStatusCanBeSold = (status) => {
    return !['PENDING', VEHICLE_STATUS.SOLD].includes((status || '').toUpperCase())
}

export const vehicleCanBeSold = (vehicle) => {
    if (vehicle.bos) {
        return false
    }

    if (!vehicle.bos && (vehicle.adStatus && vehicle.adStatus === AD_STATUS.SOLD)) return true

    return vehicleInStatusCanBeSold(get(vehicle, 'status', ''))
}

export const getVehicleDisplayName = (vehicle, t, options) => {
    let displayName = ''

    if (vehicle.name) {
        displayName = vehicle.name
    } else if (vehicle.make || vehicle.model) {
        displayName = (vehicle.make && vehicle.model)
            ? `${vehicle.make} ${vehicle.model}`
            : vehicle.make || vehicle.model
    }

    if (vehicle.regNumber && (options && options.showRegNumber)) {
        displayName = (displayName && displayName.length && (displayName !== vehicle.regNumber))
            ? `${displayName}, ${vehicle.regNumber}`
            : vehicle.regNumber
    }

    if (!displayName && vehicle.regNumber) {
        displayName = vehicle.regNumber
    }

    if (!displayName) {
        displayName = t('common:vehicle')
    }

    return displayName
}

export const getVehicleDefaultPath = (vehicleId) => {
    return getVehicleEventsPath(vehicleId)
}

export const getVehicleEventsPath = (vehicleId) => {
    return `${getVehicleBasePath({ id: vehicleId })}/tapahtumat`
}

export const getVehicleDetailsPath = (vehicleId) => {
    return `${getVehicleBasePath({ id: vehicleId })}/tiedot`
}

export const getVehicleMarketsPath = (vehicleId) => {
    return `${getVehicleBasePath({ id: vehicleId })}/hallinnointi`
}

export const getVehicleBasePath = (vehicle) => {
    return vehicle.type === 'AD'
        ? `/lisaa-ajoneuvo/ilmoitus/${getVehicleVertical(vehicle)}/${vehicle.id}`
        : `/ajoneuvo/${vehicle.id}`
}

export const getVehicleCreateAdPath = (vehicleId) => {
    return `/ajoneuvo/${vehicleId}/ilmoitus/luo`
}

export const isVehicleSoldAndBosCompleted = (vehicle) => {
    return (
        vehicle.status === VEHICLE_STATUS.SOLD &&
        vehicle.bos &&
        [BOS_STATUS.COMPLETED, BOS_STATUS.CONFIRMED].includes(vehicle.bos.status)
    )
}

export const vehicleHasActiveBos = (vehicle) => {
    const bos = getAnyVehicleBos(vehicle)

    if (!bos) return false

    switch (bos.currentUserRole) {
    case BOS_USER_ROLE.SELLER:
        return [
            BOS_STATUS.DRAFT,
            BOS_STATUS.PENDING,
            BOS_STATUS.SIGNED,
            BOS_STATUS.PAID,
            BOS_STATUS.DELIVERED,
            BOS_STATUS.FINANCING,
            BOS_STATUS.DISPUTED,
            BOS_STATUS.LOCKED,
        ].includes(bos.status)
    case BOS_USER_ROLE.BUYER:
        return [
            BOS_STATUS.DRAFT,
            BOS_STATUS.PENDING,
            BOS_STATUS.SIGNED,
            BOS_STATUS.PAID,
            BOS_STATUS.DELIVERED,
            BOS_STATUS.FINANCING,
            BOS_STATUS.CONFIRMED,
            BOS_STATUS.DISPUTED,
            BOS_STATUS.LOCKED,
        ].includes(bos.status)
    }

    return false
}

export const vehicleHasBosInStatusState = (vehicle) => {
    const bos = getAnyVehicleBos(vehicle)

    if (!bos) return false

    switch (bos.currentUserRole) {
    case BOS_USER_ROLE.SELLER:
        return [
            BOS_STATUS.PENDING,
            BOS_STATUS.SIGNED,
            BOS_STATUS.PAID,
            BOS_STATUS.DELIVERED,
            BOS_STATUS.DISPUTED,
            BOS_STATUS.LOCKED,
        ].includes(bos.status)
    case BOS_USER_ROLE.BUYER:
        return [
            BOS_STATUS.PENDING,
            BOS_STATUS.SIGNED,
            BOS_STATUS.PAID,
            BOS_STATUS.DELIVERED,
            BOS_STATUS.CONFIRMED,
            BOS_STATUS.DISPUTED,
            BOS_STATUS.LOCKED,
        ].includes(bos.status)
    }

    return false
}

export const getEngineSizes = (vehicle) => {
    const vertical = getVehicleVertical(vehicle)
    const engineSizes = []
    let max = 10.0
    switch (vertical) {
    case 'car':
        max = 10.0
        break
    case 'machine':
        max = 50.0
        break
    case 'caravan':
        max = 15.0
        break
    default:
    }

    for (let size = 0.1; size <= max;) {
        engineSizes.push({
            value: size.toFixed(1),
            name: size.toFixed(1)
        })
        size = size + 0.1
    }

    return engineSizes
}

export const getVehicleStatusText = (t, vehicle, defaultValue = '') => {
    switch (vehicle.status) {
    case VEHICLE_STATUS.SOLD:
        return t('vehicles:status.sold')
    case VEHICLE_STATUS.OLD:
        return t('vehicles:status.old')
    case VEHICLE_STATUS.DELETED:
        return t('vehicles:status.deleted')
    }

    return defaultValue
}

export const getVehiclePriceEstimateModalUrl = (location, vehicleId) => {
    return getModalUrl(location, `ajoneuvo/${vehicleId}/hinta-arvio`)
}

export const getVehiclePurchaseInfoModalUrl = (location, vehicleId) => {
    return getModalUrl(location, `ajoneuvo/${vehicleId}/myyntitieto`)
}

export const getVehiclePicturesModalPath = (location, vehicleId) => {
    return getModalUrl(location, `ajoneuvo/${vehicleId}/kuvat`)
}

export const getVehiclePicturesEditModalPath = (location, vehicleId) => {
    return `${getVehiclePicturesModalPath(location, vehicleId)}/muokkaa`
}

export const getVehicleSelectModalPath = (location, target, allowAutoselect = true) => {
    return getModalUrl(location, `ajoneuvon-valinta/goto?target=${target}${allowAutoselect ? '&allow-autoselect' : ''}`)
}

export const getVehicleDeleteModalPath = (location, vehicleId) => {
    return getModalUrl(location, `ajoneuvo/${vehicleId}/poista`)
}

export const getVehicleStatusModalPath = (location, vehicleId, vehicleStatus, soldInfoEditMode = false) => {
    return soldInfoEditMode
        ? getModalUrl(location, `ajoneuvo/${vehicleId}/ajoneuvon-tila/${vehicleStatus.toLowerCase()}/muokkaa-tilaa`)
        : getModalUrl(location, `ajoneuvo/${vehicleId}/ajoneuvon-tila/${vehicleStatus.toLowerCase()}`)
}

export const getVehicleAdStatusModalPath = (location, vehicleId, adStatus) => {
    return getModalUrl(location, `ajoneuvo/${vehicleId}/ilmoituksen-tila/${adStatus.toLowerCase()}`)
}

export const getVehicleShareModalPath = (location, vehicleId) => {
    return getModalUrl(location, `ajoneuvo/${vehicleId}/jaa`)
}

export const getVehicleShareUrl = (vehicleId, shareLink) => {
    return `/ajoneuvo/${vehicleId}/jaa/${shareLink.shareHash}`
}

export const isVehicleOwner = (user, vehicle) => {
    return user && user.id === vehicle.user.id
}

export const isVehicleOld = (vehicle) => {
    return [VEHICLE_STATUS.OLD, VEHICLE_STATUS.SOLD].includes(vehicle.status)
}
export const isVehicleStatusOld = (vehicle) => {
    return [VEHICLE_STATUS.OLD].includes(vehicle.status)
}

export const isVehicleStatusSold = (vehicle) => {
    return [VEHICLE_STATUS.SOLD].includes(vehicle.status)
}

export const isVehicleGoodForBaana = ({ vehicle, vertical }) => {
    return !isVehicleOld(vehicle) &&
        vehicle.mileage < 250000 &&
        vertical === VERTICAL.CAR
}

export const vehicleHasAd = (vehicle) => {
    return !!vehicle.adUrl
}

export const vehicleHasActiveAd = (vehicle) => {
    if (!vehicleHasAd(vehicle)) return false
    return [AD_STATUS.FORSALE].includes(vehicle.adStatus)
}

export const getVehicleStatusOldReasonText = (vehicle, t) => {
    if (vehicle.oldStatusNote && [VEHICLE_OLD_STATUS_OPTIONS.GIVEN, VEHICLE_OLD_STATUS_OPTIONS.SCRAPPED, VEHICLE_OLD_STATUS_OPTIONS.LEASING].includes(vehicle.oldStatusNote)) {
        return t(`vehicles:statusOptions.oldOptions.${vehicle.oldStatusNote}`)
    } else if (vehicle.oldStatusNote) {
        return t('vehicles:statusOptions.oldOptions.otherWithReason', { reason: vehicle.oldStatusNote })
    }
}

export const getVehicleGroupByVertical = (vertical, defaultValue = '') => {
    const group = Object.values(VEHICLE_GROUPS).find(group => group.primaryVerticals.includes(vertical))
    return group ? group.name : defaultValue
}

export const getVehicleGroupOptions = (t, vehicleClasses, group) => {
    return group.vehicleTypes.reduce((acc, id) => {
        const vehicleClass = vehicleClasses.find((vehicleClass) => vehicleClass.id === id)

        const { vertical } = vehicleClass

        const verticalGroup = acc[vertical] ? acc[vertical] : {
            label: t(`vehicles:vertical.${vertical}.name`),
            options: [],
            vertical: vertical,
        }

        verticalGroup.options.push({
            value: id,
            name: vehicleClass.vehicleType,
        })

        acc[vertical] = verticalGroup

        return acc
    }, {})
}

export const getVerticalOptions = (t, verticals = null) => {
    const list = verticals || Object.values(VERTICAL)
    return list.map(vertical => {
        return { value: vertical, name: t(`vehicles:vertical.${vertical}.name`) }
    })
}

/**
 * Return vehicle types in format that can be used in form options/select inputs.
 */
export const getVehicleTypeOptions = (t, vehicleClasses) => {
    return vehicleClasses
        .filter(vehicleClass => ENABLED_VEHICLE_VERTICALS.includes(vehicleClass.vertical))
        .reduce((acc, vehicleClass) => {
            const { vertical, id } = vehicleClass

            const verticalGroup = acc[vertical] ? acc[vertical] : {
                label: t(`vehicles:vertical.${vertical}.name`),
                options: [],
                vertical: vertical,
            }

            verticalGroup.options.push({
                value: id,
                name: vehicleClass.vehicleType,
            })

            acc[vertical] = verticalGroup

            return acc
        }, {})
}

/**
 * Return only that vehicle type which is selected by user in add vehicle.
 */
export const getVehicleTypeOptionsForVertical = (t, vehicleClasses, vehicle) => {
    return vehicleClasses
        .filter(vehicleClass => ENABLED_VEHICLE_VERTICALS.includes(vehicleClass.vertical))
        .reduce((acc, vehicleClass) => {
            const { vertical, id } = vehicleClass

            if (vehicle.vertical === vertical) {
                const verticalGroup = acc[vertical] ? acc[vertical] : {
                    label: t(`vehicles:vertical.${vertical}.name`),
                    options: [],
                    vertical: vertical,
                }

                verticalGroup.options.push({
                    value: id,
                    name: vehicleClass.vehicleType,
                })

                acc[vertical] = verticalGroup
            }

            return acc
        }, {})
}

export const getAlpahebeticalOptionGroups = (options, nameKey) => {
    const groups = []
    if (options && options.length) {
        options.forEach(option => {
            const groupName = option[nameKey].charAt(0)
            const group = groups.find(group => group.label === groupName)
            if (group) {
                group.options.push(option)
            } else {
                groups.push({
                    label: groupName,
                    options: [option]
                })
            }
        })
    }

    return groups
}

export const getVehicleMakeQuickOptions = (options, t) => {
    if (!options || !options.length) return []
    const mostPopular = []

    options.forEach(option => {
        if (option.mostPopular) {
            mostPopular.push(option)
        }
    })

    if (!mostPopular.length) return []

    return [{
        label: t('formElements:quickList.label'),
        options: [...mostPopular]
    }]
}

export const getVehicleVertical = (vehicle) => {
    try {
        return vehicle.vertical
    } catch (e) {
        // temporarily log if we have cases where vehicle vertical or vehicleType is missing
        // try catch can be removed in case no errors occurring
        logException(e)

        return get(vehicle, 'vertical', VERTICAL.CAR)
    }
}

export const getVehicleFormOfOwnershipById = (id) => {
    return FORM_OF_OWNERSHIP_BY_ID[parseInt(id)]
}

export const isVehicleInactive = (vehicle) => {
    return [VEHICLE_STATUS.OLD, VEHICLE_STATUS.SOLD].includes(vehicle.status)
}

export const wrapVehicle = (vehicle) => {
    const vehicleType = vehicle.vertical ? vehicle.vertical : vehicle.vehicleType.vertical
    switch (vehicleType) {
    case VERTICAL.CAR:
        return CarVehicle.create(vehicle)
    case VERTICAL.BIKE:
        return BikeVehicle.create(vehicle)
    case VERTICAL.CARAVAN:
        return CaravanVehicle.create(vehicle)
    case VERTICAL.MACHINE:
        return MachineVehicle.create(vehicle)
    case VERTICAL.PART:
        return PartVehicle.create(vehicle)
    default:
        return DisabledVehicle.create(vehicle)
    }
}

export const isConfirmedOwner = vehicle => {
    if (!vehicle || !vehicle.formOfOwnership) return false
    return !!(getVehicleFormOfOwnershipById(vehicle.formOfOwnership.id) === 'owner' && vehicle.formOfOwnershipConfirmedByTrafi)
}

export const isConfirmedHolder = vehicle => {
    if (!vehicle || !vehicle.formOfOwnership) return false
    return !!(getVehicleFormOfOwnershipById(vehicle.formOfOwnership.id) === 'holder' && vehicle.formOfOwnershipConfirmedByTrafi)
}

export const mapVehiclesForSelect = (t, vehicles) => {
    return vehicles.map((vehicle) => {
        return { value: vehicle.id, name: getVehicleDisplayName(vehicle, t) }
    })
}

/**
 * Sort vehicle images.
 * TODO: We need sort order via query, as this is hacky and only allows sorting of profile image first
 * @param images
 * @param profileImage
 * @returns {*}
 */
export const sortVehicleImages = (images, profileImage) => {
    images.sort((a, b) => {
        if (a.profile === profileImage) {
            return -1
        }

        if (b.profile === profileImage) {
            return 1
        }

        return 0
    })

    return images
}

export const getAvailableActions = (vehicle) => {
    const actions = [
        VEHICLE_ACTIONS.DELETE,
    ]

    switch (vehicle.status) {
    case VEHICLE_STATUS.ACTIVE:
        if (!vehicle.adStatus) {
            actions.push(VEHICLE_ACTIONS.CREATE_AD)
        }
        if (!vehicle.bos) {
            actions.push(VEHICLE_ACTIONS.CREATE_BOS)
        }
        if (vehicle.bos) {
            actions.push(VEHICLE_ACTIONS.SHOW_BOS)
        }
        if (VEHICLE_TYPES_WITH_PRICE_ESTIMATE_API.includes(vehicle.vehicleType.id)) {
            actions.push(VEHICLE_ACTIONS.PRICE_ESTIMATE)
        }
        if (!vehicle.adStatus || (vehicle.adStatus && (vehicle.adStatus !== AD_STATUS.FORSALE))) {
            actions.push(VEHICLE_ACTIONS.SET_STATUS_SOLD)
        }
        actions.push(VEHICLE_ACTIONS.SET_STATUS_OLD)
        break
    case VEHICLE_STATUS.OLD:
        if (!isBosActive(vehicle.bos)) {
            actions.push(VEHICLE_ACTIONS.SET_STATUS_ACTIVE)
        }
        if (!vehicle.adStatus || (vehicle.adStatus && (vehicle.adStatus !== AD_STATUS.FORSALE))) {
            actions.push(VEHICLE_ACTIONS.SET_STATUS_SOLD)
        }
        break
    case VEHICLE_STATUS.SOLD:
        if (vehicle.bos) {
            actions.push(VEHICLE_ACTIONS.SHOW_BOS)
        }
        actions.push(VEHICLE_ACTIONS.SET_STATUS_ACTIVE)
        break
    case VEHICLE_STATUS.PENDING:
        if (vehicle.bos) {
            actions.push(VEHICLE_ACTIONS.SHOW_BOS)
        }
        break
    }

    return actions
}

export const getAvailableAdActions = (vehicle) => {
    const { adStatus } = vehicle

    const actions = []

    if (vehicle.adUrl && [AD_STATUS.FORSALE, AD_STATUS.SOLD].includes(vehicle.adStatus)) {
        actions.push(VEHICLE_AD_ACTIONS.SHOW)
    }

    if (adStatus === AD_STATUS.FORSALE) {
        actions.push(VEHICLE_AD_ACTIONS.EDIT)
        actions.push(VEHICLE_AD_ACTIONS.DELETE)
        actions.push(VEHICLE_AD_ACTIONS.SET_SOLD)
    }

    if (adStatus === AD_STATUS.EXPIRED || adStatus === AD_STATUS.REMOVED) {
        actions.push(VEHICLE_AD_ACTIONS.SET_ACTIVE)
    }

    return actions
}

export const VERIFIED_AD_FLAG = Object.freeze({
    NOT_STARTED_AD_POST_DIRECT: 1,
    NOT_STARTED_AD_POST_SELLPAGE: 2,
    REGULAR: 3,
    VERIFIED: 4,
    REGULAR_DRAFT: 5,
    VERIFIED_DRAFT: 6,
})

export const getAnotherSellingMethodLink = (vertical) => {
    const verticalCarUrl = isProductionHost() ? 'https://www.nettiauto.com/myy-autosi' : 'https://nettiauto.almaajo.dev/myy-autosi'
    const verticalBikeUrl = isProductionHost() ? 'https://www.nettimoto.com/myy-motosi' : 'https://nettimoto.almaajo.dev/myy-motosi'
    const verticalBoatUrl = isProductionHost() ? 'https://www.nettivene.com/jata-uusi-ilmoitus' : 'https://nettivene.almaajo.dev/jata-uusi-ilmoitus'
    const verticalMachineUrl = isProductionHost() ? 'https://www.nettikone.com/postAd.php' : 'https://nettikone.almaajo.dev/postAd.php'
    const verticalPartUrl = isProductionHost() ? 'https://www.nettivaraosa.com/postAd.php' : 'https://nettivaraosa.almaajo.dev/postAd.php'
    const verticalCaravanUrl = isProductionHost() ? 'https://www.nettikaravaani.com/postAd.php' : 'https://nettikaravaani.almaajo.dev/postAd.php'

    if (vertical === VERTICAL.CAR) {
        return verticalCarUrl
    } else if (vertical === VERTICAL.BIKE) {
        return verticalBikeUrl
    } else if (vertical === VERTICAL.BOAT) {
        return verticalBoatUrl
    } else if (vertical === VERTICAL.MACHINE) {
        return verticalMachineUrl
    } else if (vertical === VERTICAL.PART) {
        return verticalPartUrl
    } else if (vertical === VERTICAL.CARAVAN) {
        return verticalCaravanUrl
    } else {
        return ''
    }
}

export const sellVehicleUrl = (vehicle) => {
    return isMobile ? vehicle?.sellVehicleUrl?.mobile : vehicle?.sellVehicleUrl?.desktop
}
